function getFromList(ligneCommandeLibelle) {
  if (ligneCommandeLibelle.length === 1) return ligneCommandeLibelle[0];
  return ligneCommandeLibelle.join(', ');
}
function getIdsProduitsEcheances(echeance) {
  if (echeance.produitsIdsLignesRegroupement.length > 0) {
    return getFromList(echeance.produitsIdsLignesRegroupement);
  }
  return getFromList(echeance.produitsIdsLignesCommande);
}
function getRefsProduitsEcheances(echeance) {
  if (echeance.referencesProduitsLignesRegroupement.length > 0) {
    return getFromList(echeance.referencesProduitsLignesRegroupement);
  }
  return getFromList(echeance.referencesProduitsLignesCommande);
}
function getLibelleEcheance(echeance) {
  if (echeance.lignesCommandeRegroupementLibelle.length > 0) {
    return getFromList(echeance.lignesCommandeRegroupementLibelle);
  }
  return getFromList(echeance.lignesCommandeLibelle);
}
function getDateDebut(echeance) {
  if (echeance.quantitePeriodicite !== 0) return echeance.dateDebut;
  if (echeance.dateDebutMinLigne) return echeance.dateDebutMinLigne;
  return echeance.dateDebut;
}
function getDateFin(echeance) {
  if (echeance.quantitePeriodicite !== 0) return echeance.dateFin;
  if (echeance.dateFinMaxLigne) return echeance.dateFinMaxLigne;
  return echeance.dateFin;
}

export default function transform(echeances) {
  echeances.forEach(echeance => {
    echeance.libelleEcheance = getLibelleEcheance(echeance);
    echeance.dateDebut = getDateDebut(echeance);
    echeance.dateFin = getDateFin(echeance);
    echeance.referencesProduits = getRefsProduitsEcheances(echeance);
    echeance.IdsProduits = getIdsProduitsEcheances(echeance);
  });
  return echeances;
}
